module.exports = __webpack_public_path__ + "img/emoji-2.972af860.png";